
import Reducer from './Reducer';
import { combineReducers } from "redux";
const RootReducer = combineReducers({
    user: Reducer,
});

export default RootReducer;
